module.exports = __webpack_public_path__ + "static/Sheffield-0146bd28fea9d527a108d73c273210e7.png";